export const INITIAL_MUSIC_TRACK_LIMIT = 5

export function normalizePlaylistLimit(limit) {
  if (!Number.isInteger(limit) || limit <= 0) return null
  return limit
}

export function applyCollectionLimit(collection, limit) {
  const normalized = normalizePlaylistLimit(limit)
  return normalized === null ? collection : collection.limit(normalized)
}

export function normalizePlaylistOffset(offset) {
  return Number.isInteger(offset) && offset >= 0 ? offset : 0
}

export function isMusicCacheBusy({ isLoadingData, backgroundLoadingActive }) {
  return Boolean(isLoadingData || backgroundLoadingActive)
}

export function shouldStopBackgroundMusicLoad({ pending, savedCount }) {
  return Number(pending) > 0 && Number(savedCount) === 0
}

export function applyCollectionWindow(collection, { limit, offset } = {}) {
  const normalizedOffset = normalizePlaylistOffset(offset)
  const offsetCollection = normalizedOffset > 0
    ? collection.offset(normalizedOffset)
    : collection

  return applyCollectionLimit(offsetCollection, limit)
}

/**
 * Materializa solo una ventana de la biblioteca local. Si el cursor llego al
 * final, vuelve al principio una unica vez. Asi el player rota la cache sin
 * copiar todos los blobs a memoria ni repetir siempre las primeras pistas.
 */
export async function loadPlaylistWindow({ load, offset = 0, limit = INITIAL_MUSIC_TRACK_LIMIT }) {
  const normalizedOffset = normalizePlaylistOffset(offset)
  let items = await load({ limit, offset: normalizedOffset })
  let resolvedOffset = normalizedOffset
  let wrapped = false

  if (items.length === 0 && normalizedOffset > 0) {
    resolvedOffset = 0
    wrapped = true
    items = await load({ limit, offset: 0 })
  }

  return {
    items,
    nextOffset: resolvedOffset + items.length,
    wrapped
  }
}
